import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../features/auth/authThunks";
import Logo from "../assets/logo-tintore.png";

import { Eye, EyeOff } from "lucide-react";

import "../styles/login.css";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const [formData, setformData] = useState({ username: "", password: "" });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleChange = (event) => {
    setformData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const result = await dispatch(loginUser(formData));
    if (loginUser.fulfilled.match(result)) {
      navigate("/appointments");
    }
  };

  const errorMessage = error
    ? typeof error === "string"
      ? error
      : JSON.stringify(error)
    : null;

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-bg-overlay" />

      <div className="login-corner-brand">
        <img src={Logo} alt="Clínica Tintoré" className="login-corner-logo" />
        <div className="login-corner-subline">Portal de clínica</div>
      </div>

      <div className="login-content">
        <section className="login-hero">
          <div className="login-hero-body">
            <h1>Bienvenid@ de nuevo</h1>
            <p>
              Gestiona agenda, pacientes y documentos en un solo lugar, con un
              entorno seguro para el equipo médico.
            </p>
          </div>

          <div className="login-hero-bottom">
            <div className="login-hero-pill">Acceso seguro · Europe/Madrid</div>
          </div>
        </section>

        <section className="login-card-wrap">
          <div className="login-card">
            <div className="login-card-header">
              <h2>Inicia sesión</h2>
              <p>Introduce tu email y tu contraseña.</p>
            </div>

            <form className="login-form" onSubmit={handleLogin}>
              <div className="login-field">
                <label htmlFor="username">Email</label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  value={formData.username}
                  onChange={handleChange}
                  autoComplete="username"
                  required
                />
              </div>

              <div className="login-field">
                <label htmlFor="password">Contraseña</label>

                <div className="login-input-with-icon">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="current-password"
                    required
                  />

                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() =>
                      setIsPasswordVisible((previousValue) => !previousValue)
                    }
                    aria-label={
                      isPasswordVisible ? "Ocultar contraseña" : "Mostrar contraseña"
                    }
                    disabled={loading}
                  >
                    {isPasswordVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <div className="login-row login-row-right">
                <button
                  type="button"
                  className="login-link"
                  onClick={() => navigate("/forgot-password")}
                  disabled={loading}
                >
                  ¿Olvidaste tu contraseña?
                </button>
              </div>

              <button className="login-submit" type="submit" disabled={loading}>
                {loading ? "Entrando…" : "Iniciar Sesión"}
              </button>

              {errorMessage && <div className="login-error">{errorMessage}</div>}
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;